import { useRef, useState } from 'react'
import { useNavigate } from 'react-router-dom'
import { MagnifyingGlassIcon } from '@radix-ui/react-icons'

import { SearchInput } from './SearchInput'
import { Button } from './Button'

export const SearchTask = () => {
  const navigate = useNavigate()
  const searchInputMethodsRef = useRef<{ clear: () => void } | undefined>(null)

  const [searchTaskTerm, setSearchTaskTerm] = useState('')

  const updateSearchTerm = (debouncedSearchTerm: string) => {
    setSearchTaskTerm(debouncedSearchTerm)
  }

  const handleSearchTask = () => {
    const searchInputMethods = searchInputMethodsRef.current

    navigate(`/painel/tasklist/${searchTaskTerm}`)

    if (searchInputMethods) {
      searchInputMethods.clear()
    }
  }

  return (
    <div className="flex gap-1">
      <SearchInput
        ref={searchInputMethodsRef}
        onSearch={updateSearchTerm}
        placeholder="Buscar"
        className="flex-1 mb-6 md:w-48 md:mb-0"
      />

      <Button
        className="h-10 ml-auto"
        disabled={!searchTaskTerm}
        onClick={() => handleSearchTask()}
      >
        <MagnifyingGlassIcon className="w-5 h-5 text-white" />
      </Button>
    </div>
  )
}
